import { WORK_STATUS } from "@/constants";

export default {
  status: WORK_STATUS.NOT_STARTED,
  error: null,
  companyName: null,
  identificationId: null,
  identifications: {},
  isDocumentEditEnabled: false,
  isPOAEditEnabled: false,
  isOnline: false
};
